var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrierScreening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 5",
    d: "M23.9999 130.848L23.9999 90.0704L23.9999 49.293C46.5207 49.293 64.7773 67.5496 64.7773 90.0704C64.7773 112.591 46.5207 130.848 23.9999 130.848Z",
    fill: "#306153"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 41.9347,
    cy: 25.5714,
    r: 17.5714,
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 92.6769,
    cy: 25.5714,
    r: 17.5714,
    fill: "#306153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 322",
    d: "M115.52 131H110.901C88.3385 131 70.0477 112.709 70.0477 90.1464V72.0288C70.0477 59.4721 80.2269 49.2929 92.7836 49.2929C105.34 49.2929 115.52 59.4721 115.52 72.0288V131Z",
    fill: "#284993"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierScreening);
export default __webpack_public_path__ + "static/media/CarrierScreening.38ab693157bd248cb44ba263fd512f16.svg";
export { ForwardRef as ReactComponent };